import { useDispatch } from 'react-redux';
import { removeWishlistItems } from '@client/myAccount/wishlists/redux/wishlist/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useRemoveWishlistItemsAction = (): typeof removeWishlistItems => {
  const dispatch = useDispatch();

  return bindActionCreators(removeWishlistItems, dispatch);
};
